import React from 'react';
import PropTypes from 'prop-types';
import styles from './welcomeScreen.scss';

const WelcomeScreen = ({ moveToLogin, moveToJoin }) => {
    return (
        <div className={styles.welcomeScreen} data-testid="welcome.container">
            <div className={styles.welcomeScreenContent} data-testid="welcome.content">
                <img className={styles.utrSportsWithLogo} alt="utr sports logo" src="/img/utrsports-with-logo.svg" data-testid="welcome.logo" />
                <h2 className={styles.header} data-testid="welcome.header">Pickleball & Tennis</h2>
                <button
                    onClick={moveToLogin}
                    type="button"
                    className="btn btn-primary-inv"
                    style={{ width: '300px', marginBottom: '24px' }}
                    data-testid="welcome.sign-in-btn"
                >
                    Sign In
                </button>
                <button
                    onClick={moveToJoin}
                    className="btn btn-inv"
                    type="button"
                    style={{ width: '300px' }}
                    data-testid="welcome.join-btn"
                >
                    Join
                </button>
            </div>
        </div>
    );
};

WelcomeScreen.propTypes = {
    moveToLogin: PropTypes.func.isRequired,
    moveToJoin: PropTypes.func.isRequired,
};

export default WelcomeScreen;
